import { IRangeDatePickerOption } from "@livechat/design-system";

import { CustomDateRangeFilterId } from "constants/filters";

export interface ISingleItemProps {
  label: string;
  value: string;
  pickerType?: PickerType;
}

export interface ISingleItem {
  key: string;
  props: ISingleItemProps;
}

export enum InputName {
  From = "from",
  To = "to",
}

export enum PickerType {
  Time = "Time",
  Date = "Date",
}

export interface ICustomRangeDatePickerOption extends IRangeDatePickerOption {
  id: CustomDateRangeFilterId;
  relativeValue?: {
    from?: string;
    to?: string;
  };
  pickerType?: PickerType;
}
